import functions from "./functions";
import mixins from "./mixins";
import variables from "./variables";

const utils = { functions, mixins, ...variables };

export default utils;
